module.exports = __webpack_public_path__ + "img/GROUP_BY_TABLE.a27f062b.svg";